import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const ArrowLeftThin = (props) => (
  <Icon viewBox="0 0 6 14" {...props}>
    <g>
      <path id="Dark-Breadcrumb-Arrow" d="M5.2 14l.8-.7L1.4 7 6 .7 5.2 0 0 7z" className="st0" />
    </g>
  </Icon>
);
/*eslint-enable */

export default ArrowLeftThin;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/ArrowLeftThin.js